import { PropTypes } from "prop-types";
import {
  SIGNOL_COLOUR_NAMES,
  SIGNOL_COLOUR_NAMES_WITH_SHADES,
} from "@signolteam/shared/colours";
import { AppUtils } from "@src/utils";
import * as icons from "@src/assets/icons";

export const COMMON_CONTROLS = {
  className: {
    propType: PropTypes.string,
    description: "Additional CSS classes",
    controlType: "text",
  },
  industry: {
    propType: PropTypes.oneOf(["aviation", "shipping", "road"]).isRequired,
    controlType: "select",
    options: ["aviation", "shipping", "road"],
    description: "Customer Industry",
  },
  isLoading: {
    propType: PropTypes.bool,
    controlType: "boolean",
    defaultValue: false,
    description: "Loading state",
  },
  icon_name: {
    propTypes: PropTypes.string,
    controlType: "select",
    options: Object.keys(icons).sort(AppUtils.sortStrings),
    description: "Icon name",
  },
  /** includes colours without shades */
  colour_name: {
    propType: PropTypes.string.isRequired,
    controlType: "select",
    options: SIGNOL_COLOUR_NAMES,
  },
  colour_name_include_transparent: {
    propType: PropTypes.string.isRequired,
    controlType: "select",
    options: ["none", "transparent", ...SIGNOL_COLOUR_NAMES],
  },
  colour_name_shaded: {
    propType: PropTypes.string.isRequired,
    controlType: "select",
    options: SIGNOL_COLOUR_NAMES_WITH_SHADES,
  },
  behaviour_acronym: {
    propType: PropTypes.string.isRequired,
    controlType: "select",
    options: [
      "CD",
      "DFA",
      "EAEU",
      "EF",
      "EMO",
      "EPM",
      "ESFOC",
      "ESGU",
      "ESM",
      "ET",
      "ITC",
      "MTU",
      "OBL",
      "OD",
      "ODFL",
      "ODGU",
      "OFM",
      "OS",
      "OT",
      "OTD",
      "PD",
      "RETI",
      "RETO",
      "SES",
      "SETI",
    ],
  },
  customerCode: {
    propType: PropTypes.string,
    controlType: "select",
    options: [
      "CHR",
      "VS",
      "HAG",
      "UTB",
      "NAVG",
      "CAPE",
      "TUIC",
      "SEFE",
      "BSM",
      "NYK",
    ],
    description: "Customer Code",
  },
  trackingActionKey: {
    propType: PropTypes.string,
    controlType: "text",
    description: "User Activity tracking 'actionKey'",
  },
};
